import type {Sector} from "crqlar-react-common/dist/models/sector/sector.model";
import {useAuthorizedViaAdmin} from "crqlar-react-common/dist/utils/hooks/admin/useAuthorizedViaAdmin";
import {useLocalize} from "crqlar-react-common/dist/utils/text.util";
import type {ReactElement} from "react";
import {PageShell, type TabRoute} from "../layout/PageShell";
import AccommodationInsightsTab from "../insights/AccommodationInsightsTab";
import {ReservationCalendar} from "./ReservationCalendar";
import AccommodationReservationList from "./lists/AccommodationReservationList";

interface Props {
    appName: string;
    icon: ReactElement;
    tabPath: (tab: string) => string;
    sector: Sector;
}

export default function Accommodation({appName, icon, tabPath, sector}: Props) {
    const {t} = useLocalize();
    const isAuthorizedViaAdmin = useAuthorizedViaAdmin();

    const tabs: TabRoute[] = [
        {
            path: tabPath("calendar"),
            label: t("Calendar"),
            render: () => sector.id
                ? <ReservationCalendar sector={sector}/>
                : null,
        },
        {
            path: tabPath("list"),
            label: t("List"),
            render: () => sector.id
                ? <AccommodationReservationList sector={sector}/>
                : null,
        },
        // ...(isAuthorizedViaAdmin
        //     ? [{
        //         path: tabPath("insights"),
        //         label: t("Insights"),
        //         render: () => <AccommodationInsightsTab sector={sector}/>,
        //     }]
        //     : []),
    ];

    return (
        <PageShell
            icon={icon}
            title={appName}
            documentTitle={appName}
            tabs={tabs}
        />
    );
}
